export const UPLOAD_PREVIEW_WIDTH = 200;

export const suggestionTypes = {
  LOW_CONTRAST: 1,
  LOW_RESOLUTION: 2
};

export const statusValues = {
  RESOLVED: 1,
  UNRESOLVED: 0
};
